<template>
    <div v-if="showSuccess">
        <slot name="thankyou" :bind="this"></slot>
    </div>
    <div v-else>
        <slot name="form" :bind="this"></slot>
    </div>
</template>
<script>
import FormValidator from "lib/form-validator.mjs";
export default {
    name: 'ContactForm',
    props: {
        target: {
            type: String,
            required: true
        },
        csrf: {
            type: String,
            required: true
        },
        redirect: {
            type: String,
            required: true
        }
    },
    watch: {
        name(val) {
            this.hideError('name');
            this.formValidator.setValue('name', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError( 'name', error );
                    this.evaluateButtonStatus();
                }
            );
        },
        email(val) {
            this.hideError('email');
            this.formValidator.setValue('email', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError( 'email', error );
                    this.evaluateButtonStatus();
                }
            );
        },
        subject(val) {
            this.hideError('subject');
            this.formValidator.setValue('subject', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError( 'subject', error );
                    this.evaluateButtonStatus();
                }
            );;
        },
        message(val) {
            this.hideError('message');
            this.formValidator.setValue('message', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError( 'message', error );
                    this.evaluateButtonStatus();
                }
            );;
        }
    },
    data() {
        return {
            formValidator: new FormValidator({
                name: {
                    required: true,
                    type: 'string',
                    min: 3,
                    max: 20
                },
                email: {
                    required: true,
                    type: 'email',
                },
                subject: {
                    required: true,
                    type: 'string',
                    min: 3,
                    max: 100
                },
                message: {
                    required: true,
                    type: 'string',
                    min: 10,
                    max: 1000
                }
            }, {
                name: '',
                email: '',
                subject: '',
                message: ''
            }),
            name: '',
            email: '',
            subject: '',
            message: '',
            errors: {
                name: { init: 1 },
                email: { init: 1 },
                subject: { init: 1 },
                message: { init: 1 }
            },
            generalError:false,
            submitLock: true,
            showSuccess: false
        }
    },
    methods: {
        hideError( name ){
            this.errors[ name ] = {};
        },
        showError( name, error ){
            this.errors[ name ] = {};
            this.errors[ name ][ error ] = true;
        },
        evaluateButtonStatus(){
            for( let error in this.errors ){
                if( Object.keys( this.errors[ error ] ).length > 0 ){
                    this.submitLock = true;
                    return;
                }
            }
            this.submitLock = false;
        },
        getPayload(){
            const payload = {
                name: this.name,
                email: this.email,
                subject: this.subject,
                message: this.message
            }
            return payload;
        },
        submit(){
            const valid = this.formValidator.isValid();
            if( valid ) {
                this.send();
            }
        },
        send(){
            const payload = this.getPayload();
            this.generalError = false;
            this.submitLock = true;
            this.$emit( 'wait', true );
            fetch( this.target, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrf
                },
                body: JSON.stringify( payload )
            }).then( response => {
                this.$emit( 'wait', false );
                if( response.status === 200 ){
                    this.showSuccess = true;
                    this.$emit( 'success' );
                    setTimeout(() => {
                        window.location.href = this.redirect;
                    }, 1000);
                } else {
                    this.generalError = true;
                    this.$emit( 'error' );
                }
            }).catch( error => {
                this.$emit( 'wait', false );
                this.generalError = true;
                this.$emit( 'error' );
            });
        }
    },
}
</script>
